import React from "react";
import {
  Grid,
  TextField,
  Button,
  withStyles,
  MenuItem,
  InputLabel,
  Select,
  Input,
  FormControl
} from "material-ui";
import Icon from "material-ui/Icon";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { validateFormData } from "../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../common/datatypetool";
import { CustomDataEnum } from "./customenum";
import Duration from "../common/duration";
import FrameLossLimit from "../common/framelosslimit";

class CustomData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      setUpType: null,
      trafficType: 0,
      ieee802_3: null,
      numberOfSessions: null,
      expectedLineRate: null,
      isChanged: false,
      trafficBandwidth: [],
      frameSize: [],
      trafficRate: 0.1,
      infoRate: 0,
      frameLossLimit: 0,
      countValue: 0,
      percentValue: 0,
      duration: 10,
      frameFill: [],
      hours: "00",
      minutes: "00",
      seconds: "00",
      isBandwidthAuto: false,
      hideCount: false,
      countValue: 0,
      percentValue: 0,
      countDefaultValue: 0,
      percentDefaultValue: 0,
      trafficRateDefaultValue: 0.1,
      errors: {},
      isRestore: false,
      showRestoreConfirm: false,
      isCustomdataUpdated: false
    };
  }

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false
    });
    this.onCustomDataSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };

  updateCustomData = subtestSettings => {
    let frameSize = this.mapEnumValue(subtestSettings.framesize, "framesize");
    this.splitDuration(subtestSettings.duration);
    this.setState({
      id: subtestSettings.id,
      trafficBandwidth: this.mapEnumValue(
        subtestSettings.trafficbandwidth,
        "trafficbandwidth"
      ),
      frameSize: frameSize,
      frameFill: this.mapEnumValue(subtestSettings.framefill, "framefill"),
      trafficRate:
        subtestSettings.trafficbandwidth === 2
          ? 10
          : subtestSettings.trafficrate,
      frameLossLimit: subtestSettings.framelosslimit,
      countValue: subtestSettings.count,
      percentValue: subtestSettings.percent,
      duration: subtestSettings.duration,
      hideCount: subtestSettings.framelosslimit === 1 ? true : false,
      trafficType: subtestSettings.traffictype,
      ieee802_3: subtestSettings.ieee802_3,
      numberOfSessions: subtestSettings.noofsessions,
      expectedLineRate: subtestSettings.expectedlinerate,
      setUpType: subtestSettings.setuptype,
      countDefaultValue: subtestSettings.count,
      percentDefaultValue: subtestSettings.percent,
      trafficRateDefaultValue: subtestSettings.trafficrate,
      isBandwidthAuto: subtestSettings.trafficbandwidth === 2 ? true : false,
      infoRate:
        subtestSettings.trafficbandwidth === 2
          ? this.calculateInfoRate(frameSize, 10)
          : this.calculateInfoRate(frameSize, subtestSettings.trafficrate)
    });
  };

  validateDefaultValue = (e, type) => {
    const { trafficRateDefaultValue, frameSize } = this.state;
    const { translate } = this.props;
    let currentErrors = this.state.errors;
    delete currentErrors.trafficRate;
    if (e.target.value === 2) {
      this.setState({ trafficRate: 10, errors: currentErrors });
    } else {
      this.setState({
        trafficRate: trafficRateDefaultValue,
        errors: currentErrors,
        infoRate: this.calculateInfoRate(frameSize, trafficRateDefaultValue)
      });
    }
  };

  toTrafficRateFixed = (e, frameSize) => {
    let updatedInfoRate = 0;
    let newTrafficRate = ToReal(e.target.value);
    newTrafficRate = newTrafficRate.split(".");
    if (newTrafficRate.length > 2) {
      this.setState({ errors: { trafficRate: {} } });
    } else if (newTrafficRate.length === 1) {
      updatedInfoRate = this.calculateInfoRate(frameSize, newTrafficRate[0]);
      updatedInfoRate = isNaN(updatedInfoRate) ? 0 : updatedInfoRate;
      this.setState({
        trafficRate: newTrafficRate[0],
        infoRate: updatedInfoRate
      });
    } else {
      if (newTrafficRate[1].length > 4) {
        e.preventDefault();
      } else {
        updatedInfoRate = this.calculateInfoRate(
          frameSize,
          ToReal(e.target.value)
        );
        updatedInfoRate = isNaN(updatedInfoRate) ? 0 : updatedInfoRate;
        this.setState({
          trafficRate: ToReal(e.target.value),
          infoRate: updatedInfoRate
        });
      }
    }
  };

  toFixed = (e, numberOfDigit, newErrors) => {
    let value = ToReal(e.target.value);
    value = value.split(".");
    if (value.length > 2) {
      this.setState({ errors: { [e.target.name]: {} } });
    } else if (value.length === 1) {
      this.setState({
        [e.target.name]: value[0],
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      if (value[1].length > numberOfDigit) {
        e.preventDefault();
      } else {
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
      }
    }
  };

  onChange = e => {
    const { errors, trafficBandwidth, frameSize, trafficRate } = this.state;
    let newErrors = errors;
    let updatedInfoRate = 0;
    switch (e.target.name) {
      case "trafficBandwidth":
        {
          if (e.target.value === 2) {
            this.validateDefaultValue(e, "trafficbandwidth");
            updatedInfoRate = this.calculateInfoRate(frameSize, 10);
            this.setState({
              trafficBandwidth: this.mapEnumValue(
                e.target.value,
                "trafficbandwidth"
              ),
              isChanged: true,
              isBandwidthAuto: true,
              infoRate: updatedInfoRate,
              isRestore: false
            });
          } else {
            this.validateDefaultValue(e, "trafficbandwidth");
            updatedInfoRate = this.calculateInfoRate(frameSize, trafficRate);
            this.setState({
              trafficBandwidth: this.mapEnumValue(
                e.target.value,
                "trafficbandwidth"
              ),
              isChanged: true,
              isBandwidthAuto: false,
              isRestore: false
            });
          }
        }
        break;
      case "frameSize":
        {
          let newFrameSize = this.mapEnumValue(e.target.value, "framesize");
          if (
            trafficBandwidth &&
            trafficBandwidth.length &&
            trafficBandwidth[0].key === 2
          ) {
            updatedInfoRate = this.calculateInfoRate(newFrameSize, 10);
          } else {
            updatedInfoRate = this.calculateInfoRate(newFrameSize, trafficRate);
          }
          this.setState({
            frameSize: newFrameSize,
            isChanged: true,
            infoRate: updatedInfoRate,
            isRestore: false
          });
        }
        break;
      case "trafficRate":
        {
          delete newErrors[e.target.name];
          this.toTrafficRateFixed(e, frameSize);
          this.setState({
            isChanged: true,
            errors: newErrors,
            isRestore: false
          });
        }
        break;
      case "frameFill":
        {
          this.setState({
            frameFill: this.mapEnumValue(e.target.value, "framefill"),
            isChanged: true,
            isRestore: false
          });
        }
        break;
      case "countValue":
        delete newErrors[e.target.name];
        let onlyInterger = ToInt(e.target.value);
        this.setState({
          [e.target.name]: onlyInterger,
          isChanged: true,
          errors: newErrors,
          isRestore: false
        });
        break;
      case "percentValue":
        delete newErrors[e.target.name];
        this.toFixed(e, 5, newErrors);
        break;
      default:
        {
          delete newErrors[e.target.name];
          this.setState({
            [e.target.name]: ToReal(e.target.value),
            isChanged: true,
            errors: newErrors,
            isRestore: false
          });
        }
        break;
    }
  };

  splitDuration = duration => {
    let hours = 0,
      minutes = 0,
      seconds = 0;
    if (parseInt(duration) >= 3600) {
      hours = parseInt(duration / 3600);
      duration = parseInt(duration % 3600);
    }
    if (parseInt(duration) >= 60) {
      minutes = parseInt(duration / 60);
      duration = parseInt(duration % 60);
    }
    this.setState({
      hours: ToDuration(hours + ""),
      minutes: ToDuration(minutes + ""),
      seconds: ToDuration(duration + ""),
      isRestore: false
    });
  };

  mapEnumValue = (key, type) => {
    switch (type) {
      case "trafficbandwidth":
        return CustomDataEnum.TrafficData.filter(data => data.key === key);
      case "framesize":
        return CustomDataEnum.FrameSize.filter(data => data.key === key);
      case "framefill":
        return CustomDataEnum.FrameFill.filter(data => data.key === key);
    }
  };

  onCustomDataSave = () => {
    const {
      frameLossLimit,
      hours,
      minutes,
      seconds,
      countValue,
      isRestore
    } = this.state;
    const { translate, error, isTestEdit } = this.props;

    let errors;
    let validationObj = {
      duration: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 10,
          maxValue: 86399,
          message: translate("formfield_error_general_required")
        }
      },
      trafficRate: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.0001,
          maxValue: 10,
          message: translate("formfield_error_general_required")
        }
      },
      countValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0,
          maxValue: 99999,
          message: translate("formfield_error_general_required")
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required")
        }
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.0,
          maxValue: 10.0,
          message: translate("formfield_error_general_required")
        }
      }
    };

    let duration =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    errors = validateFormData(
      { ...this.state, duration: duration },
      validationObj
    );
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (this.state.trafficRate === 0) {
      errors["trafficRate"] = {};
    }
    if (duration === 0) {
      errors["duration"] = {};
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      const {
        id,
        trafficBandwidth,
        frameSize,
        trafficRate,
        infoRate,
        frameLossLimit,
        countValue,
        percentValue,
        frameFill,
        setUpType,
        trafficType,
        ieee802_3,
        expectedLineRate,
        numberOfSessions,
        hideCount
      } = this.state;
      let payload = {
        id: id,
        setuptype: "customdata",
        traffictype: trafficType,
        trafficbandwidth: trafficBandwidth[0].key,
        trafficrate: trafficRate,
        inforate: infoRate,
        framesize: frameSize[0].key,
        framelosslimit: hideCount ? 1 : 0,
        count: countValue,
        percent: percentValue === "" ? 0 : percentValue,
        duration: duration,
        framefill: frameFill[0].key,
        ieee802_3: ieee802_3,
        expectedlinerate: expectedLineRate,
        noofsessions: numberOfSessions
      };
      if (!error) {
        this.setState({
          isChanged: false,
          errors: {},
          countDefaultValue: countValue,
          percentDefaultValue: percentValue,
          frameLossDefaultValue: frameLossLimit,
          trafficRateDefaultValue: trafficRate
        });
      } else {
        this.setState({ isChanged: false, errors: {} });
      }
      //this.props.updateSubTestSettings(payload);

      if (isTestEdit) {
        this.props.updateSubTestSettings(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateSubTestSettings(payload);
      }
      if (isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
    }
  };

  renderValue = selectedValue => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };

  onKeyDown = event => {
    if (event.key === ".") {
      event.preventDefault();
    }
  };

  onInput = event => {
    let additionMinutes = 0,
      additionalHours = 0;
    let newErrors = this.state.errors;
    delete newErrors["duration"];
    let onlyInteger = ToDuration(event.target.value);
    const { hours, minutes, seconds } = this.state;

    if (event.target.name === "seconds" && parseInt(onlyInteger) > 59) {
      additionMinutes = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionMinutes = ToDuration(
        parseInt(minutes) + parseInt(additionMinutes) + ""
      );
      if (parseInt(additionMinutes) > 59) {
        additionalHours = parseInt(additionMinutes / 60);
        additionMinutes = ToDuration(parseInt(additionMinutes % 60) + "");
      }
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        minutes: additionMinutes,
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else if (event.target.name === "minutes" && parseInt(onlyInteger) > 59) {
      additionalHours = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      this.setState({
        [event.target.name]: onlyInteger + "",
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    }
  };

  calculateInfoRate = (frameSize, trafficRate) => {
    frameSize = frameSize && frameSize.length ? frameSize[0].value : 1518;
    let framePereconds =
      (parseFloat(trafficRate) * 1000000000) / (8 * (parseInt(frameSize) + 20));
    let infoRate = (parseInt(frameSize) * 8 * framePereconds) / 1000000;
    return infoRate.toFixed(6);
  };

  frameLossLimitToggle = () => {
    const { countDefaultValue, percentDefaultValue } = this.state;
    const { translate } = this.props;
    let currentErrors = this.state.errors;
    let errors;
    let validationObj = {
      countValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0,
          maxValue: 99999,
          message: translate("formfield_error_general_required")
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required")
        }
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.0,
          maxValue: 10.0,
          message: translate("formfield_error_general_required")
        }
      }
    };

    errors = validateFormData({ ...this.state }, validationObj);
    const missingFieldName = Object.keys(errors)[0];

    if (Object.keys(errors).length) {
      if (errors.countValue) {
        delete currentErrors.countValue;
        this.setState({
          hideCount: !this.state.hideCount,
          isChanged: true,
          isRestore: false,
          errors: currentErrors,
          countValue: countDefaultValue
        });
      } else {
        delete currentErrors.percentValue;
        this.setState({
          hideCount: !this.state.hideCount,
          isChanged: true,
          isRestore: false,
          errors: currentErrors,
          percentValue: percentDefaultValue
        });
      }
    } else {
      this.setState({
        hideCount: !this.state.hideCount,
        isChanged: true,
        isRestore: false
      });
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };
  onRestoreConfirm = () => {
    //this.props.updateUpTime(this.props.selectedTest, this.props.upTime);
    this.updateCustomData(this.props.subtestSettings);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  render() {
    const {
      isChanged,
      trafficBandwidth,
      frameSize,
      trafficRate,
      isBandwidthAuto,
      errors,
      infoRate,
      hours,
      minutes,
      seconds,
      frameFill,
      hideCount,
      countValue,
      percentValue,
      isRestore
    } = this.state;
    const {
      translate,
      classes,
      isTestEdit,
      subtestSettings,
      customdataDetails,
      testEdit,
      modified
    } = this.props;

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("sub_test_empty_target_search_t3", {
              name: "Custom Data"
            })}
          />
        )}
        <Content translate={translate}>
          {subtestSettings &&
            (trafficBandwidth && trafficBandwidth.length > 0) && (
              <Grid container>
                <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
                <Grid item xs={!isTestEdit ? 8 : 10}>
                  <Grid container>
                    <Grid item xs={6}>
                      <FormControl fullWidth margin="normal" error={false}>
                        <InputLabel id="traffic-bandwidth">
                          {translate("subtest_traffic_bandwidth")}
                        </InputLabel>
                        <Select
                          labelId="traffic-bandwidth"
                          name="trafficBandwidth"
                          renderValue={() => this.renderValue(trafficBandwidth)}
                          onChange={this.onChange}
                          input={
                            <Input
                              value={() => this.renderValue(trafficBandwidth)}
                            />
                          }
                          autoWidth={false}
                        >
                          {CustomDataEnum.TrafficData.map(trafficData => {
                            return (
                              <MenuItem
                                key={trafficData.value}
                                value={trafficData.key}
                              >
                                {trafficData.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <FormControl fullWidth margin="normal" error={false}>
                        <InputLabel id="frame-size">
                          {translate("uptime_frame_size")}
                        </InputLabel>
                        <Select
                          labelId="frame-size"
                          name="frameSize"
                          renderValue={() => this.renderValue(frameSize)}
                          onChange={this.onChange}
                          input={
                            <Input value={() => this.renderValue(frameSize)} />
                          }
                          autoWidth={false}
                        >
                          {CustomDataEnum.FrameSize.map(frameSize => {
                            return (
                              <MenuItem
                                key={frameSize.value}
                                value={frameSize.key}
                              >
                                {frameSize.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <TextField
                        className={classes.textField}
                        error={errors.trafficRate}
                        label={translate("subtest_traffic_rate")}
                        name="trafficRate"
                        margin="normal"
                        value={trafficRate}
                        onChange={this.onChange}
                        disabled={isBandwidthAuto}
                        fullWidth
                        helperText={
                          errors.trafficRate
                            ? translate("subtest_number_range", {
                                start: 0.0001,
                                end: "10.0000"
                              })
                            : ""
                        }
                      />
                      <TextField
                        className={classes.textField}
                        name="infoRate"
                        margin="normal"
                        value={infoRate}
                        onChange={this.onChange}
                        disabled={true}
                        label={translate("subtest_info_rate")}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}></Grid>
                  </Grid>
                  <FrameLossLimit
                    translate={translate}
                    classes={classes}
                    errors={errors}
                    onChange={this.onChange}
                    hideCount={hideCount}
                    frameLossLimitToggle={this.frameLossLimitToggle}
                    percentValue={percentValue}
                    countValue={countValue}
                    countStart={0}
                    countEnd={99999}
                    percentStart={"0.00000"}
                    percentEnd={"10.00000"}
                  />
                  <Grid container>
                    <Grid item xs={6}>
                      <Duration
                        translate={translate}
                        hours={hours}
                        minutes={minutes}
                        seconds={seconds}
                        errors={errors}
                        classes={classes}
                        onKeyDown={this.onKeyDown}
                        onInput={this.onInput}
                        durationStart={"00:00:10"}
                        durationEnd={"23:59:59"}
                      />
                      <FormControl fullWidth margin="normal" error={false}>
                        <InputLabel id="frame-fill">
                          {translate("subtest_frame_fill")}
                        </InputLabel>
                        <Select
                          labelId="frame-fill"
                          disabled={true}
                          name="frameFill"
                          renderValue={() => this.renderValue(frameFill)}
                          onChange={this.onChange}
                          input={
                            <Input value={() => this.renderValue(frameFill)} />
                          }
                          autoWidth={false}
                        >
                          {CustomDataEnum.FrameFill.map(frameFill => {
                            return (
                              <MenuItem
                                key={frameFill.value}
                                value={frameFill.key}
                              >
                                {frameFill.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>
                  </Grid>
                  {!isTestEdit && (
                    <div align="right">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={this.onCustomDataSave}
                      >
                        {translate("sub_set_ping_save_target")}
                      </Button>
                    </div>
                  )}
                </Grid>
                <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
              </Grid>
            )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: "Custom Data"
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit &&
          subtestSettings &&
          (trafficBandwidth && trafficBandwidth.length > 0) && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {customdataDetails && !testEdit ? (
                  <Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (<Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>) : null }
              </div>
              <div style={{ display: "inline-block", marginRight: "20px" }}>
                <Button
                  disabled={!isChanged}
                  color="accent"
                  raised
                  onClick={() => this.onCustomDataSave()}
                  className={classes.saveTarget}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  // component life cycles
  componentWillMount() {
    const { getSubtestSettings } = this.props;
    getSubtestSettings("customdata");
  }

  componentWillReceiveProps(nextProps) {
    const { subtestSettings, isTestEdit, customdataDetails } = nextProps;

    if (isTestEdit && !customdataDetails) {
      if (subtestSettings && subtestSettings != this.props.subtestSettings) {
        this.updateCustomData(subtestSettings);
      }
    } else if (isTestEdit && customdataDetails) {
      if (
        (customdataDetails &&
          this.props.customdataDetails != customdataDetails) ||
        !this.state.isCustomdataUpdated
      ) {
        this.updateCustomData(customdataDetails);
        this.setState({ isCustomdataUpdated: true });
      }
    } else {
      if (subtestSettings && subtestSettings != this.props.subtestSettings) {
        this.updateCustomData(subtestSettings);
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}

export default withRouter(withStyles(styles)(CustomData));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/customdata/index.js